export const formatDateForAgGrid = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return d.toISOString().split("T")[0];
};

export const onFilterChanged = (params) => {
    if (params.api.getDisplayedRowCount() === 0) {
        params.api.showNoRowsOverlay();
    } else {
        params.api.hideOverlay();
    }
};
